var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "Signature_Control"
  }, [_c("div", {
    staticClass: "box_nav",
    style: {
      width: _vm.itemData.widthSet
    }
  }, [_c("div", {
    staticClass: "paragraphstyle",
    domProps: {
      innerHTML: _vm._s(_vm.itemData.content)
    }
  })])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };